import React, { useEffect, useState } from "react";
import Header, { HeaderLeft, HeaderRight } from "./Header";
import useDeviceScreen from "../../../Hooks/useDeviceScreen";
import "../../../Core/HeaderTitle";
import Breadcrumb from "../../../Components/base/Breadcrumb";
import {
  dashboardMenu,
  buildingMenu,
  financialYearMenu,
  insuranceRenewalMenu,
  meetingRegisterMenu,
  termDepositMenu,
  configurationMenu,
  assistanceMenu,
} from "../../../menu"; // import your menus

const DefaultHeader = () => {
  const { width } = useDeviceScreen();
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  const [headerTitle, setHeaderTitle] = useState(null);
  const [menuTitle, setMenuTitle] = useState(null);

  // --- Watch header-title DOM for changes ---
  useEffect(() => {
    const headerEl = document.querySelector("header-title");
    if (!headerEl) return;

    // Initial read
    setHeaderTitle(headerEl.textContent);

    // MutationObserver to detect content/value changes
    const observer = new MutationObserver(() => {
      setHeaderTitle(headerEl.textContent);
    });

    observer.observe(headerEl, {
      characterData: true,
      subtree: true,
      childList: true,
    });

    return () => observer.disconnect();
  }, []);

  // --- Watch Menu-title DOM for changes ---
  useEffect(() => {
    const titleEl = document.querySelector("menu-title");
    if (!titleEl) return;

    // Initial read
    setMenuTitle(titleEl.textContent);

    // MutationObserver to detect content/value changes
    const observer = new MutationObserver(() => {
      setMenuTitle(titleEl.textContent);
    });

    observer.observe(titleEl, {
      characterData: true,
      subtree: true,
      childList: true,
    });

    return () => observer.disconnect();
  }, []);

  // --- Whenever menuTitle changes, update breadcrumb ---
  useEffect(() => {
    if (!menuTitle) return;

    const path1 = findMenuPath(dashboardMenu, menuTitle);
    const path2 = findMenuPath(buildingMenu, menuTitle);
    const path3 = findMenuPath(financialYearMenu, menuTitle);
    const path4 = findMenuPath(termDepositMenu, menuTitle);
    const path5 = findMenuPath(insuranceRenewalMenu, menuTitle);
    const path6 = findMenuPath(meetingRegisterMenu, menuTitle);
    const path7 = findMenuPath(configurationMenu, menuTitle);
    const path8 = findMenuPath(assistanceMenu, menuTitle);
    const menuPath = path1 || path2 || path3 || path4 || path5 || path6 || path7 || path8;

    if (menuPath) {
      const list = menuPath.map((item) => ({
        title: item.text,
        to: `/${item.path}`,
      }));
      setBreadcrumbList(list);
    } else {
      setBreadcrumbList([]);
    }
  }, [headerTitle]);

  return (
    <Header>
      <HeaderLeft>
        <div className="fs-3 fw-bold">
          <header-title>Initial Title</header-title>
          <menu-title style={{ display: "none" }}>Initial Title</menu-title>
        </div>
      </HeaderLeft>
      <HeaderRight>
        <Breadcrumb list={breadcrumbList} />
      </HeaderRight>
    </Header>
  );
};

export default DefaultHeader;

// --- Recursive menu search ---
function findMenuPath(menuObj, targetText, path = []) {
  for (const key in menuObj) {
    const item = menuObj[key];
    if (item.text === targetText) return [...path, item];
    if (item.subMenu) {
      const subPath = findMenuPath(item.subMenu, targetText, [...path, item]);
      if (subPath) return subPath;
    }
  }
  return null;
}
